<template>
  <div class="dragbox">
  <div class="pContainer" v-if="edit">
    <div>
      <SearchInput :width="'100%'" :defaultValue="searchText" @input="searchText=$event"/>
    </div>
    <div>
      <div class="cates">
        <div v-for="(cate, c) in categoriessort" :key="`cate-${c}`"
        @click="category=cate"
        :class="category?.category===cate.category ? 'selected' : ''">{{cate.category || '其他'}}</div>
      </div>
      <div :style="{paddingRight: '5px'}" class="cateProducts">
        <div draggable @dragstart="startDrag($event, item._id)"
        v-for="(item, i) in category?.items || []" :key="`item-${i}`">
          <!-- <div>{{item.t==='single' ? '單' : '組'}}</div> -->
          <div>{{item.name}}</div>
          <div>{{formatDollarInt(item.price)}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="selectContainer">
    <div>
      <div>指定商品</div>
      <div :style="{marginInline:'auto'}"></div>
      <EditBtn v-if="!edit" @click="products=JSON.parse(JSON.stringify(sortCate));edit=true"/>
      <DelBtn v-else @click="products=[]" title="清空"/>
    </div>
    <div>
      <div v-if="!edit" class="cateProducts">
        <div v-for="(item, i) in sortCate" :key="`p-${i}`">
          <!-- <div>{{item.t==='single' ? '單' : '組'}}</div> -->
          <div>{{item.name}}</div>
          <div>{{formatDollarInt(item.price)}}</div>
        </div>
      </div>
      <div class="drop" v-else
      @drop="onDrop($event);changeBG(false, 0)"  ref="drop"
      @dragenter="changeBG(true, 0)"
      @dragleave="changeBG(false, 0)"
      @dragover.prevent
      @dragenter.prevent>
      <draggable class="cateProductsSelected" v-model="products">
        <div draggable v-for="(item, i) in products" :key="`p-${i}`">
          <!-- <div>{{item.t==='single' ? '單' : '組'}}</div> -->
          <div>{{item.name}}</div>
          <div>{{formatDollarInt(item.price)}}</div>
          <DelBtn @click="products.splice(i, 1)" title="刪除"/>
        </div>
      </draggable>
      </div>
    </div>
  </div>
  <div class="Btns">
    <div>
      <div :style="{marginLeft: 'auto'}"></div>
      <BtnsS v-if="edit" @cancel="edit=false" @save="save"/>
    </div>
    <div></div>
  </div>
  </div>
</template>

<script>
// import SaveBtn from '../../../components/btn/save.vue'
import draggable from 'vuedraggable'
import DelBtn from '../../../components/btn/del1.vue'
import EditBtn from '../../../components/btn/edit.vue'
import SearchInput from '../../../components/input/search.vue'
import { postapi } from '../../../store/fetch'
export default {
  props: ['categories', 'project'],
  components: { SearchInput, DelBtn, EditBtn, draggable },
  data () {
    return {
      category: null,
      product: null,
      searchText: null,
      products: [],
      edit: false
    }
  },
  computed: {
    prods () {
      return [].concat(...this.categories.map(e => e.items))
    },
    sortCate () {
      const items = [
        ...this.project.specialProducts.map(e => { return { ...e, t: 'single' } }),
        ...this.project.specialSets.map(e => { return { ...e, t: 'set' } })
      ]
      const cateItems = this.project.cateItems
      items.sort((a, b) => cateItems.indexOf(a._id) > cateItems.indexOf(b._id) ? 1 : -1)
      return items
    },
    categoriessort () {
      const categories = JSON.parse(JSON.stringify(this.categories))
      const c2 = categories.filter(e => e.order === -1)
      const c = categories.filter(e => e.order !== -1)
      c.sort((a, b) => a.order > b.order ? 1 : -1)
      if (this.searchText) {
        const searchText = new RegExp(this.searchText, 'ig')
        const cates = [...c, ...c2].map(e => {
          return { ...e, items: e.items.filter(e => searchText.test(e.name)) }
        }).filter(e => e.items.length)
        return cates
      } else {
        return [...c, ...c2]
      }
    }
  },
  watch: {
    products () {
    },
    categoriessort: {
      deep: true,
      handler () {
        if (this.category && this.category.category && this.categoriessort.map(e => e.category).includes(this.category?.category)) {
          this.category = this.categoriessort.find(e => e.category === this.category.category)
        } else {
          this.category = null
        }
      }
    }
  },
  mounted () {
    this.category = this.categoriessort[0]
  },
  methods: {
    async save () {
      const r = await postapi(`projects/${this.project._id}/base`, {
        specialProducts: this.products.filter(e => e.t === 'single').map(e => e._id),
        specialSets: this.products.filter(e => e.t === 'set').map(e => e._id),
        cateItems: this.products.map(e => e._id)
      })
      if (r) {
        this.$emit('refresh')
        this.edit = false
      }
    },
    changeBG (bo) {
      const ref = this.$refs.drop || this.$refs.drop
      if (bo) {
        ref.classList.add('in')
      } else {
        ref.classList.remove('in')
      }
    },
    startDrag (event, item) {
      console.log('startDrag', item)
      event.dataTransfer.dropEffect = 'move'
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('itemID', item)
    },
    onDrop (event) {
      const itemID = event.dataTransfer.getData('itemID')
      const item = this.prods.find(it => it._id === itemID)
      if (item) {
        this.products.push(item)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.dragbox {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  height: calc(100vh - 160px);
  padding-bottom: 10px;
}
.Btns {
  display: grid;
  grid-template-rows: 40px calc(100vh - 230px);
  padding: 10px 20px;
  gap: 10px;
  &>div:nth-child(1) {
    display: flex;
    align-items: center;
  }
}
.selectContainer {
  width: 600px;
  height: calc(100vh - 180px);
  display: grid;
  grid-template-rows: 40px calc(100vh - 230px);
  padding: 10px 20px;
  gap: 10px;
  &>div:nth-child(1) {
    display: flex;
    font-size: 24px;
    align-items: center;
    color: var(--color-pri);
    gap: 20px;
  }
  &>div:nth-child(2) {
    display: flex;
    flex-direction: column;
    border: 1px solid #CACACA;
    border-radius: 5px;
    padding: 5px;
    position: relative;
    max-height: calc(100vh - 230px);
    overflow-y: auto;
  }
  .cateProductsSelected {
    z-index: 10;
    padding: 15px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    padding: 3px 6px;
    gap: 10px;
    // height: 100%;
    &>div {
      width: 100%;
      height: 64px;
      min-height: 64px;
      font-size: 20px;
      font-weight: 400;
      background-color: var(--color-infobox);
      padding: 3px 10px;
      display: grid;
      grid-template-columns: 1fr 5em 2em;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      &>div:nth-child(1) {
        text-align: start;
      }
      &>div:nth-child(2) {
        text-align: end;
      }
    }
  }
}
.drop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
}
.drop {
  min-height: 60px;
  width: 100%;
  &.in {
    background-color: var(--color-bar);
  }
}
.cateProducts {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  padding: 3px 6px;
  gap: 10px;
  // height: 100%;
  &>div {
    width: 100%;
    height: 64px;
    min-height: 64px;
    font-size: 20px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--color-infobox);
    padding: 3px 10px;
    &>div:nth-child(1) {
      text-align: start;
    }
  }
}
.cates {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-inline: 2px 8px;
  padding-block: 1px 10px;
  &>div {
    width: 144px;
    height: 90px;
    border-radius: 5px;
    min-height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-pri);
    font-size: 20px;
    background-color: #FFFFFF;
    border: 3px solid var(--color-pri);
    font-weight: 700;
    letter-spacing: .05em;
    &.selected {
      background-color: var(--color-pri);
      color: #FFFFFF;
    }
  }
}
.pContainer {
  width: 600px;
  height: calc(100vh - 180px);
  display: grid;
  grid-template-rows: 40px calc(100vh - 220px);
  padding: 10px 20px;
  gap: 10px;
  &>div:nth-child(1) {
    display: flex;
  }
  // background-color: var(--color-infobox);
  &>div:nth-child(2) {
    display: grid;
    grid-template-columns: 160px 400px;
    gap: 10px;
    &>div{
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }
  }
}
</style>
